import { ComponentRef, Injectable, Injector, ViewContainerRef } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private containerRef: ViewContainerRef | null = null;
  private activeModal: ComponentRef<any> | null = null;

  constructor(private injector: Injector) {}

  public setContainerRef(containerRef: ViewContainerRef) {
    this.containerRef = containerRef;
  }

  public open<T>(component: any, data?: any): Promise<any> {
    document.body.classList.add('no-scroll');
    return new Promise((resolve, reject) => {
      if (!this.containerRef) {
        throw new Error('Modal container not set. Call setContainerRef first.');
      }

      // Clear existing modals
      this.containerRef.clear();

      // Dynamically create the component
      const componentRef = this.containerRef.createComponent(component, {
        injector: Injector.create({
          providers: [
            { provide: 'MODAL_DATA', useValue: data },
            { provide: 'MODAL_CLOSE', useValue: resolve },
          ],
          parent: this.injector,
        }),
      });

      this.activeModal = componentRef;

      (componentRef as any).instance.onClose = () => {
        this.close();
        reject();
      };
    });
  }

  public close() {
    document.body.classList.remove('no-scroll');
    if (this.activeModal) {
      this.activeModal.destroy();
      this.activeModal = null;
    }
    if (this.containerRef) {
      this.containerRef.clear();
    }
  }
}
